<template>
  <md-toolbar
    id="toolbar"
    :class="extraNavClasses + ' ' + navClass"
    :color-on-scroll="colorOnScroll"
    class="md-transparent md-absolute"
    md-elevation="0"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <img :src="imgUrl" />
        <span style="padding-right: 20px"></span>
        <a href="/"><h1 class="md-title">华龙科技</h1></a>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          :class="{ toggled: toggledClass }"
          class="md-just-icon md-simple md-toolbar-toggle"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <md-list-item
                href="javascript:;"
                @click="scrollToElementById('product-tx')"
              >
                <i class="material-icons">account_tree</i>
                <p>数字警务</p>
              </md-list-item>

              <md-list-item
                href="javascript:;"
                @click="scrollToElementById('product-aq')"
              >
                <i class="material-icons">fingerprint</i>
                <p>数字赋能</p>
              </md-list-item>

              <md-list-item
                href="javascript:;"
                @click="scrollToElementById('product-pt')"
              >
                <i class="material-icons">cloud</i>
                <p>光通信</p>
              </md-list-item>

              <md-list-item href="#/about">
                <i class="material-icons">people_alt</i>
                <p>关于华龙</p>
              </md-list-item>

              <md-list-item href="#/contact">
                <i class="material-icons">chat</i>
                <p>联系我们</p>
              </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;

function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import MobileMenu from "@/layout/MobileMenu";

export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false,
      imgUrl: require("@/assets/img/logo.png")
    };
  },
  computed: {
    showDownload() {
      const excludedRoutes = ["login", "landing", "profile"];
      return excludedRoutes.every(r => r !== this.$route.name);
    },
    navClass() {
      return this.$route.path === "/" ? "home" : this.$route.path;
    }
  },
  methods: {
    scrollToElementById(element) {
      if (this.$route.path !== "/") {
        this.$router.push({ path: "/#" + element });
      }
      let element_id = document.getElementById(element);
      if (element_id) {
        element_id.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    },
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      //console.log(document.body.scrollTop);
      //console.log(document.documentElement.scrollTop);
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > 0) {
        this.extraNavClasses = `md-${this.type}`;
        navbarColor.classList.remove("md-transparent");
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
          navbarColor.classList.add("md-transparent");
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    },
    scrollToElement() {
      let element_id = document.getElementById("downloadSection");
      if (element_id) {
        element_id.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  }
};
</script>
